import { render, staticRenderFns } from "./AquisitionMethodSelector.vue?vue&type=template&id=4cd23f9c"
import script from "./AquisitionMethodSelector.vue?vue&type=script&lang=ts"
export * from "./AquisitionMethodSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports